import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    iconYellow: {
      color: palette.navCompanyContextActions,
      fontSize: 22,
    },
    iconGreen: {
      color: palette.navAdmin,
      fontSize: 22,
    },
    iconGray: {
      color: palette.navSuperAdminActions,
      fontSize: 22,
    },
    iconBlue: {
      color: palette.navOperator,
      fontSize: 22,
    },
    maintenanceManual: {
      paddingTop: '10px',
      paddingLeft: '10px',
    },
    cardsContent: {
      display: 'flex',
    },
    alignCards: {
      marginTop: 32,
      marginLeft: 20,
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },

    FormContainer: {
      display: 'flex',
      padding: '0px 25px',
      marginBottom: 24,
      alignItems: 'center',
      justifyContent: 'flex-start',

      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 7,
      },
      '& .MuiGrid-item': {
        padding: '8px 3px',
      },
      '& .MuiCheckbox-root ': {
        margin: '0px 8px 0px 8px',
        padding: 0,
      },
    },
    textFieldContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: '100%',
      maxWidth: '98%',
    },
    subject: { marginRight: 8 },
    datePicker: {
      [breakpoints.up(500)]: {
        width: '47%',
      },
      [breakpoints.down(500)]: {
        width: '100%',
      },
    },
    iconMaintenance: { marginRight: 5 },
    customSubheaderText: {
      fontSize: 12,
      fontWeight: 500,
    },
    customSubheaderIcon: {
      fontSize: 15,
      color: palette.navCompanyContextActions,
    },
    deleteButtons: {
      marginTop: 15,
    },
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
    },
    maintenanceDetailsBoxActive: {
      border: `0.6px solid ${palette.green}`,
      borderRadius: 8,
      backgroundColor: palette.backgroundLightGreen,
      marginBottom: 8,
    },
    maintenanceDetailsBoxInactive: {
      border: `0.6px solid ${palette.red}`,
      borderRadius: 8,
      backgroundColor: palette.backgroundLightRed,
      marginBottom: 8,
    },
    maintenanceDetailsText: {
      fontSize: 12,
      margin: 12,
      color: palette.darkGray,
    },
    maintenanceTitle: {
      fontSize: 14,
      color: palette.darkGray,
      fontWeight: 550,
      margin: '0px 0px 8px 0px',
    },
    maintenanceHistoryButton: {
      border: `1px solid ${palette.blue}`,
      color: palette.blue,
      fontSize: 12,
      marginRight: 8,
    },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
    maxWidth: 700,
  },
};
